import _ from "lodash"
import { Navigate, useParams } from "react-router-dom"
import { z } from "zod"

import { CatalogProductsTable } from "~/pages/Brand/Products/List/Components/ProductsTables/catalog/CatalogProductsTable"
import { CustomFieldsProductsTable } from "~/pages/Brand/Products/List/Components/ProductsTables/custom-fields/CustomFieldsProductsTable"
import { StandardsProductsTable } from "~/pages/Brand/Products/List/Components/ProductsTables/standards/StandardsProductsTable"
import { TraceabilityProductsTable } from "~/pages/Brand/Products/List/Components/ProductsTables/traceability/TraceabilityProductsTable"
import { ProductsListView } from "~/pages/Brand/Products/List/constants.ts"

export const ProductTableFactory = () => {
  const params = useParams()

  const view = z
    .nativeEnum(ProductsListView)
    .safeParse(_.camelCase(params.view) || ProductsListView.GENERAL)

  const resolver = {
    [ProductsListView.GENERAL]: CatalogProductsTable,
    [ProductsListView.CUSTOM_FIELDS]: CustomFieldsProductsTable,
    [ProductsListView.CERTIFICATES]: StandardsProductsTable,
    [ProductsListView.TRACEABILITY]: TraceabilityProductsTable,
  }

  if (!view.success) {
    return <Navigate to="/products" />
  }

  const TableComponent = resolver[view.data]

  return <TableComponent />
}
